module.exports = __webpack_public_path__ + "static/media/fishmeat.506dfadb.webp";